import { createAsyncThunk } from "@reduxjs/toolkit";
import GuestApi from "api/GuestApi";

export const fetchOneGuest = createAsyncThunk(
  "fetchOneGuest",
  ({ companyId, guestId }: { companyId: number; guestId: number }) =>
    GuestApi.fetchOneGuest(companyId, guestId)
);
